/**
 * Update the browser favicon with a notification badge
 * @param {number} count - Number of unread notifications (0 to remove badge)
 */
export const updateFaviconWithBadge = (count = 0) => {
	// If count is 0, restore original favicon
	if (count === 0) {
		resetFavicon();
		return;
	}

	// If count > 0, create favicon with badge
	const canvas = document.createElement("canvas");
	canvas.width = 32;
	canvas.height = 32;
	const ctx = canvas.getContext("2d");

	// Load the original favicon image
	const img = new Image();
	img.crossOrigin = "anonymous";

	img.onload = () => {
		// Draw the original favicon
		ctx.drawImage(img, 0, 0, 32, 32);

		// Draw red badge
		const badgeSize = 10;
		const badgeX = 32 - badgeSize / 2 - 2;
		const badgeY = badgeSize / 2 + 2;

		// Outer red circle (badge background)
		ctx.beginPath();
		ctx.arc(badgeX, badgeY, badgeSize / 2 + 1, 0, 2 * Math.PI);
		ctx.fillStyle = "#dc3545"; // Bootstrap red color
		ctx.fill();

		// Inner white border
		ctx.beginPath();
		ctx.arc(badgeX, badgeY, badgeSize / 2, 0, 2 * Math.PI);
		ctx.fillStyle = "#dc3545";
		ctx.fill();

		// Update all favicon links with the new image
		updateFaviconLinks(canvas.toDataURL("image/png"));
	};

	img.onerror = () => {
		console.warn("Failed to load favicon image, using fallback");
		// Fallback: create a simple yellow background with red badge
		ctx.fillStyle = "#ffc107"; // Yellow background
		ctx.fillRect(0, 0, 32, 32);

		// Red badge
		ctx.beginPath();
		ctx.arc(24, 8, 8, 0, 2 * Math.PI);
		ctx.fillStyle = "#dc3545";
		ctx.fill();

		updateFaviconLinks(canvas.toDataURL("image/png"));
	};

	// Start loading the image - use absolute path to original favicon
	img.src = `${window.location.origin}/favicon/favicon-32x32.png`;
};

/**
 * Update all favicon link elements with new data URL
 * @param {string} dataUrl - The new favicon data URL
 */
const updateFaviconLinks = (dataUrl) => {
	// Update the main favicon
	const favicon32 = document.querySelector('link[rel="icon"][sizes="32x32"]');
	if (favicon32) {
		favicon32.href = dataUrl;
	}

	const favicon16 = document.querySelector('link[rel="icon"][sizes="16x16"]');
	if (favicon16) {
		favicon16.href = dataUrl;
	}

	// Also update shortcut icon if it exists
	const shortcutIcon = document.querySelector('link[rel="shortcut icon"]');
	if (shortcutIcon) {
		shortcutIcon.href = dataUrl;
	}
};

/**
 * Reset favicon to original
 */
export const resetFavicon = () => {
	const favicon32 = document.querySelector('link[rel="icon"][sizes="32x32"]');
	const favicon16 = document.querySelector('link[rel="icon"][sizes="16x16"]');
	const shortcutIcon = document.querySelector('link[rel="shortcut icon"]');

	// Add cache-busting parameter to force browser reload
	const cacheBuster = `?v=${Date.now()}`;

	if (favicon32) {
		favicon32.href = `/favicon/favicon-32x32.png${cacheBuster}`;
	}
	if (favicon16) {
		favicon16.href = `/favicon/favicon-16x16.png${cacheBuster}`;
	}
	if (shortcutIcon) {
		shortcutIcon.href = `/favicon/favicon-32x32.png${cacheBuster}`;
	}
};
